import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TokenType } from './interfaces/token-type.interface';

@Component({
  selector: 'gtd-token-type',
  templateUrl: './token-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TokenTypeComponent {
  @Input() data: string;
  public tokenTypesLabels = {
    [TokenType.AFFILIATE]: $localize`:@@api_tokens.affiliate_type:Affiliate`,
    [TokenType.AFFILIATE_MANAGER]: $localize`:@@api_tokens.affiliate_manager_type:Affiliate Manager`,
    [TokenType.USER]: $localize`:@@api_tokens.user_type:User`,
  };
}
